exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-request-failure{position:relative}.card-request-failure .icon-cross{position:absolute;top:10px;right:10px;font-size:15px;color:#aeaeae;cursor:pointer}.card-request-failure .icon-warning{display:block;font-size:40px;width:40px;margin:auto;padding-top:22px;padding-bottom:15px;color:#c8175e}.card-request-failure p{max-height:70px;overflow-x:hidden;text-align:center;letter-spacing:.5px;padding:0 15px;line-height:1.3;font-family:Stag Sans}.card-request-failure p strong{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestFailure/cardRequestFailure.scss
// module id = 1619
// module chunks = 0